import React, { useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DataContext } from "../dataContext";
import BottomButton from "../components/BottomButton";

const TransferFailed = ({ homePath }) => {
  const { history } = useContext(DataContext);
  const navigate = useNavigate();

  const urlParams = useParams();

  const transfer = history.find(({ id }) => id === urlParams.id);

  return (
    <main className="page_without_nav ">
      {transfer ? (
        <div className="np-hero" style={{ flex: 1, justifyContent: "center" }}>
          <span className="np-hero-icon np-hero-icon-danger" aria-hidden="true">
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="6" y1="6" x2="18" y2="18" />
              <line x1="18" y1="6" x2="6" y2="18" />
            </svg>
          </span>
          <h1>Error</h1>
          <p data-cy="transfer_processed_message">Transfer failed</p>
        </div>
      ) : (
        <div className="center_page">Transfer Not Found</div>
      )}
      {BottomButton(() => navigate(homePath), "Return home")}
    </main>
  );
};

export default TransferFailed;
